module.exports = __webpack_public_path__ + "static/img/ent-detail-83.8aac28f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-83.jpg
// module id = 2XA4
// module chunks = 51